var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-flex-start" },
    [
      _c("FormDatepicker", {
        staticClass: "w-full customInput",
        attrs: {
          value: _vm.start,
          calendarClass: "right-0 xl:left-0",
          customInputClass:
            "rounded-lg text-storm-gray text-sm h-1 leading-normal",
          label: "",
          iconStyle: _vm.iconStyle,
          inputClass: [_vm.inputClass, `w-full`],
          placeholder: _vm.placeholder,
        },
        on: { input: _vm.handleStartInput },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }